import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DtoMetric, DtoPreviewItem, DtoSubCategory, DtoSubCategoryMetric, PowerBiReport, ReportFolderCatalogItem } from '../../../models/package-center.model';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Tabs } from '../data-management.component';
import { SubCategoryService } from './sub-category.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProdetailsModalComponent } from '../prodetails-modal/prodetails-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { Controls, MatDialogCloseEvent, Mode } from '../../../const';
import { PageEvent } from '@angular/material/paginator';
import { PowerBiReportService } from '../../powerbi-report/powerbi-report.service';
import { MatAutocompleteActivatedEvent, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html'
})
export class SubCategoryComponent implements OnInit, OnChanges {
  @Output() setPageTitle = new EventEmitter<{}>();
  @Output() close = new EventEmitter<void>();
  @Input() showForm: boolean = false;
  @Input() isCurrentTab: string = "";
  @Input() searchTriggered: boolean = false;
  @Input() searchTerm: string = "";

  isEdit: boolean = false;

  readonly emptyReport: PowerBiReport = {
        id: '00000000-0000-0000-0000-000000000000',
        name:"Placeholder report",
        description:"This is a placeholder report. It does not get generated.",
        itemType: ""
      };

  powerBiReports: ReportFolderCatalogItem =  {
    id: "",
    name: "",
    reports:[this.emptyReport],
    subFolders:[]
  };
  
  subCategoryToEdit: DtoSubCategoryMetric = {} as DtoSubCategoryMetric;
  tabs = Tabs
  subCategories: DtoSubCategoryMetric[] = [];
  metrics: DtoMetric[] = [];
  metricsForCreate: DtoMetric[] = [];
  subCategoryControls = Controls;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  sortSubcategoryNameAsc: boolean = true;
  sortColumn: string = "";
  sortDirection: string = "";

  reportIdValue: string[] = [];
  subCategoryForm: FormGroup = new FormGroup({
    subCategoryName: new FormControl([], [
      Validators.required,
      Validators.maxLength(200)
    ]),
    subCategoryDisplayName: new FormControl([], [
      Validators.maxLength(200)
    ]),
    reportId: new FormControl([], [
      Validators.required
    ]),
    metrics: new FormControl([], [
      Validators.required
    ]),
    sectorId: new FormControl(0, [
      Validators.required
    ]),
  });

  constructor(private toasterService: ToastrService,
    private dialog: MatDialog,
    private subCategoryService: SubCategoryService,
    private powerBIReportService: PowerBiReportService) { }

  ngOnInit(): void {
    this.getSubCategories();
    this.getMetricsForSubCategory();
    this.getPowerBiReports();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['showForm']?.currentValue){
      this.subCategoryForm.controls['sectorId'].setValue(Number(sessionStorage.getItem('sector')));
    }
    if(this.searchTriggered){
      this.pageNumber = 0
      this.pageOffSet = 0;
      this.getSubCategories();
    }
  }

  
  isReportSelected(option: string): boolean {
    return this.reportIdValue.includes(option);
  }


  isValidReport(reportIdList: string|null): boolean {
    
    if(reportIdList==null || reportIdList=='') return true;

    if(reportIdList.toLowerCase()==this.emptyReport.id)
      return true;

    var parts = reportIdList.split(';')
    
    return !parts.some((v)=>!this.isValidSingleReport(v))
    
  }

  isValidSingleReport(reportId: string|null): boolean
  {
    if(reportId==null || reportId=='') return true;

    if(reportId.toLowerCase()==this.emptyReport.id)
      return true;

    var reports = this.powerBiReports.reports.map((x)=>x.id);
    if(reports.includes(reportId)) return true;

    for(const f1 of this.powerBiReports.subFolders)
    {
      reports=f1.reports.map((x)=>x.id);
      if(reports.includes(reportId)) return true;

      for(const f2 of f1.subFolders)
      {
        reports=f2.reports.map((x)=>x.id);
        if(reports.includes(reportId)) return true;

        for(const f3 of f2.subFolders)
        {
          reports=f3.reports.map((x)=>x.id);
          if(reports.includes(reportId)) return true;
          
        }
      }
    }
    return false;
  }

  generateMultiReportValues(event: MatAutocompleteSelectedEvent){
    const selectedValue = event.option?.value??'';
    var reportIdValue = this.reportIdValue ;
    let parts = reportIdValue; // trim & remove empty
      
    if(selectedValue==this.emptyReport.id)
      parts=[this.emptyReport.id];

    if (!parts.includes(selectedValue)) {
      parts.push(selectedValue);
    }
    else if(selectedValue!=this.emptyReport.id){
      //toggle as remove
      parts=parts
        .filter((p: any) => p!=selectedValue);
    }
    
    if(parts.length>1)
      parts = parts.filter((p: any) => p!=this.emptyReport.id)

    this.reportIdValue=parts
      .filter((p: any) => p!='');

    this.subCategoryForm.controls['reportId'].setValue(this.reportIdValue.join('; '));
  }

  getPowerBiReports(){
    const pbr = this.powerBiReports;
    const numEntries = pbr.reports.length;
    
    if(pbr.subFolders.length==0){
      this.powerBIReportService.getCatalogItems().subscribe({
        next: (reports) => {
          // Handle the successful response here
          const folder = reports as ReportFolderCatalogItem; 
          pbr.subFolders.push(folder);
        },
        error: (err) => {
          this.toasterService.error('Unable to read list of available reports', 'Error');
          console.error('Error fetching reports:', err);
        }
      });
    }
  }

  getSubCategories(sortColumn = "", sortDirection = "") {
    let sectorId = Number(sessionStorage.getItem('sector'));
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
      
    this.subCategoryService.getSubCategory(sectorId, payload).subscribe((res: DtoSubCategoryMetric[] | any) => {
      this.subCategories = res;
      this.totalRecords = res.length ? parseInt(res[0].totalRecords) : 0;
      this.subCategoryForm.reset();
      this.showForm = false;
      this.isEdit = false;
      this.close.emit();
      this.getMetricsForSubCategory();
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getSubCategories();
  }

  showCreateForm() {
    this.subCategoryForm.reset();
    this.showForm = true;
    this.isEdit = false;
    this.setPageTitle.emit(
      {
        tab: this.tabs.Module,
        mode: Mode.Create
      }
    );
  }

  getMetricsForSubCategory() {
    let sectorId = Number(sessionStorage.getItem('sector'));
    this.subCategoryService.getMetricsForSubCategory(sectorId, {} as DtoSubCategory).subscribe((response: DtoMetric[] | any) => {
      this.metrics = response;
      this.metricsForCreate = this.metrics;
      this.showForm = false;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  createSubCategory() {
    let payload: DtoSubCategoryMetric = JSON.parse(JSON.stringify(this.subCategoryForm.value))
    if (this.isEdit) {
      payload.subCategoryId = this.subCategoryToEdit.subCategoryId;
      this.subCategoryService.updateSubCategory(payload).subscribe((res => {
        this.toasterService.success("Subcategory updated successfully", "Success");
        this.getSubCategories();
      }), (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      })
      return;
    }
    this.subCategoryService.createSubCategory(payload).subscribe(response => {
      if (response) {
        this.toasterService.success("Subcategory created successfully", "Success");
        this.getSubCategories();
      }
    }, (error: HttpErrorResponse) => {
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  editSubCategory(subCategoryDetail: DtoSubCategoryMetric) {
    this.subCategoryForm.controls['sectorId'].setValue(Number(sessionStorage.getItem('sector')));
    this.setPageTitle.emit({
      tab: this.tabs.Module,
      mode: Mode.Edit
    })
    let sectorId = Number(sessionStorage.getItem('sector'));
    this.isEdit = true;
    this.showForm = true;
    this.subCategoryToEdit = subCategoryDetail
    let subCategory: DtoSubCategory = {
      subCategoryId: subCategoryDetail.subCategoryId,
      subCategoryName: subCategoryDetail.subCategoryName || "",
      subCategoryDisplayName: subCategoryDetail.subCategoryDisplayName || "",
      packageSubCategoryId: 0
    }

    this.reportIdValue = (subCategoryDetail.reportId??'')
      .toLowerCase()
      .split(';')
      .filter((p: any) => p!='');

    this.subCategoryService.getMetricsForSubCategory(sectorId, subCategory).subscribe((res: DtoMetric[] | any) => {
      this.metrics = res;
      let metricsList = this.metrics.filter(metric => {
        return subCategoryDetail.metrics.some(subCategoryMetric => metric.metricId == subCategoryMetric.metricId);
      });
      this.subCategoryForm.patchValue({
        subCategoryName: subCategoryDetail.subCategoryName,
        subCategoryDisplayName: subCategoryDetail.subCategoryDisplayName,
        metrics: metricsList,
        reportId: subCategoryDetail.reportId
      });
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  checkIfMetricExists() {
    if (!this.metrics.length) {
      this.toasterService.warning("No new metric is available. Please create a metric to proceed!")
    }
  }

  deleteSubCategory(subCategoryDetail: DtoSubCategoryMetric) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the Analytics Toolkit?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.subCategoryService.deleteSubCategory(subCategoryDetail.subCategoryId).subscribe((res) => {
          if (res) {
            this.toasterService.success("Analytics Toolkit deleted successfully!", "Success");
            this.getSubCategories();
          }
        }, (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        })
      }
    });
  }

  previewPopup(itemToPreview: DtoMetric[] = []) {
    this.dialog.open(ProdetailsModalComponent, {
      width: '1000px',
      data: {
        singleItemPreview: true,
        itemToPreview: (itemToPreview.map((x: DtoMetric) => ({
          groupName: null,
          itemName:x.metricName})) as DtoPreviewItem[]),
        title: 'Added Metrics'
      }
    })
  }

  closeCreateForm() {
    this.subCategoryForm.reset();
    this.metrics = this.metricsForCreate;
    this.showForm = false;
    this.close.emit();
    this.isEdit = false;
  }

  activateDeactivateSubCategory(subCategoryDetail: DtoSubCategoryMetric) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: subCategoryDetail.status,
        message: "Are you sure want to" + (subCategoryDetail.status ? " inactivate" : " activate") + " the Analytics Toolkit?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.subCategoryService.updateSubCategoryStatus(subCategoryDetail.subCategoryId).subscribe((res) => {
          if (res) {
            this.toasterService.success("Analytics Toolkit" + (subCategoryDetail.status ? " activated" : " inactivated") + " successfully", "Success");
            this.getSubCategories();
          }
        }, (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
          subCategoryDetail.status = !subCategoryDetail.status;
        })
      }
      else {
        subCategoryDetail.status = !subCategoryDetail.status
      }
    });
  }

  removeMetric(metricValue: DtoMetric) {
    let currentMetrics = this.subCategoryForm.controls['metrics'].value;
    this.subCategoryForm.controls['metrics'].setValue(currentMetrics.filter((x: DtoMetric) => x.metricId != metricValue.metricId))
  }

}
